// import { configureStore, getDefaultMiddleware } from "redux-starter-kit";
import { rootReducer } from "./reducers";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";

import { save, load } from "redux-localstorage-simple";

const initialState = {
  user: {
    nick_name: "",
    room_key: "",
    room_password: "", //What the user thinks the room password is, which may or may not be right
    view_mode: "full", //full, video, chat. Normally mobiles will start with 'chat'.
    ideal_position: 0 //where we think we should be, based on received information + time
  },
  room: {
    video_url: "",
    subtitle_url: "",
    video_position: 0, //seconds
    video_position_timestamp: 0, // unixtime that we received our last position update
    video_length: 0, //seconds
    is_playing: false,
    password: null
  },
  chats: [],
  present: [] //array of {client_id:, connection_id:}
};


/* Configurestore doesn't seem to work well with typescript, so we do it manually */
const loadedState =  load({ states: ["user"], namespace: "couchpile25", preloadedState: initialState });
const store = createStore(rootReducer, loadedState, 
  composeWithDevTools(
    applyMiddleware(
      thunk, save({ states: ["user"], namespace: "couchpile25" })
    )
  )
);


export default store;
